import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { t } from '../i18n/index.ts';
import { action } from '../lib/api.ts';
import { clock, dateTime } from '../lib/format.ts';
import { useSession } from '../lib/session.tsx';
import type { SupportStatus } from '../screens/manage/Support.tsx';
import { Icon } from './Icon.tsx';

/**
 * Support access, always in sight. Support sees in red that it works inside someone's business
 * and until when; the owner sees that the door is open, with a way to close it.
 */
/** "18:30" today, the date as well when later. */
const time = (at: string) => (new Date(at).toDateString() === new Date().toDateString() ? clock(at) : dateTime(at));

export function SupportBanner() {
  const { me, can, signOut } = useSession();
  const [open, setOpen] = useState<SupportStatus['open']>(null);
  const owner = !me?.support && can('support.manage');
  useEffect(() => {
    if (!owner) return;
    let stop = false;
    const load = () => action<SupportStatus>('support.status').then((s) => !stop && setOpen(s.open), () => {});
    void load();
    const timer = window.setInterval(load, 60_000);
    return () => {
      stop = true;
      window.clearInterval(timer);
    };
  }, [owner]);
  if (me?.support) {
    return (
      <div className="support-banner support-banner-in" role="alert">
        <Icon name="shield" size={18} />
        <span>{t('support.banner_in', { name: me.support.by, time: time(me.support.until) })}</span>
        <button type="button" className="btn btn-sm support-leave" onClick={() => void signOut()}>
          {t('support.leave')}
        </button>
      </div>
    );
  }
  if (!owner || !open || Date.parse(open.expires_at) <= Date.now()) return null;
  return (
    <div className="support-banner" role="status">
      <Icon name="eye" size={18} />
      <span>{t('support.banner_open', { time: time(open.expires_at) })}</span>
      <Link className="btn btn-sm btn-ghost" to="/manage/support">
        {t('support.manage_link')}
      </Link>
    </div>
  );
}
